import React from "react";
import { Link } from "react-router-dom";
import "./DataRiskManager.css";

const DataRiskManager = (props) => {
	return (
		<div>
			<div>Settings</div>
			<div className="d-flex container mt-5 ms-5" style={{ width: "80%" }}>
				<div className="row">
					<Link to="/tenants/apps/DRM/activity-code" className="anc col">
						<div className="d-flex align-items-center icon">
							<i className="fa-solid fa-users img"></i>
							<div className="text">
								Activity Code Management
							</div>
						</div>
					</Link>
				</div>
			</div>
		</div>
	);
};

export default DataRiskManager;
